class HeroSection extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.endDiv = null;
    this.logo = null;
    this.slides = [];
    this.currentSlideIndex = 0;
    
    // Bind methods
    this.handleScroll = this.handleScroll.bind(this);
    this.handleContainerScroll = this.handleContainerScroll.bind(this);
    this.updateLogoColor = this.updateLogoColor.bind(this);
  }

  connectedCallback() {
    this.container = this.querySelector('.fullpagecontainer');
    this.endDiv = document.getElementById('endfullpage');
    this.logo = document.querySelector('.header__heading-logo .cc_logo');
    this.slides = Array.from(this.querySelectorAll('.slide'));
    
    if (!this.container) return;

    // Initial state check
    this.checkInitialState();
    
    // Set up event listeners
    window.addEventListener('scroll', this.handleScroll);
    
    if (this.container) {
      this.container.addEventListener('scroll', this.handleContainerScroll);
    }

    // Initialize navigation
    this.initializeNavigation();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.container) {
      this.container.removeEventListener('scroll', this.handleContainerScroll);
    }
  }

  checkInitialState() {
    if (!this.endDiv || !this.logo) return;
    
    const endDivTop = this.endDiv.offsetTop;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (endDivTop < scrollTop) {
      this.container?.classList.remove('fix');
      this.logo?.classList.remove('cc_logo_w');
    } else {
      this.container?.classList.add('fix');
      this.updateLogoColor();
    }
  }

  handleScroll() {
    if (!this.container || !this.endDiv || !this.logo) return;
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > 0) {
      this.container.classList.remove('scr');
      
      if (scrollTop > this.endDiv.offsetTop) {
        this.container.classList.remove('fix');
        this.logo.classList.remove('cc_logo_w');
      } else {
        this.container.classList.add('fix');
        this.updateLogoColor();
      }
    } else {
      this.container.classList.add('scr');
    }
  }

  handleContainerScroll() {
    if (!this.container) return;
    
    const containerHeight = this.container.offsetHeight || this.container.clientHeight;
    const scrollTop = Math.ceil(this.container.scrollTop);
    const atSnappingPoint = scrollTop % containerHeight <= 1;
    const timeout = atSnappingPoint ? 0 : 150;
    
    setTimeout(() => {
      if (!timeout) {
        const slideNumber = Math.round(scrollTop / containerHeight + 1);
        this.setCurrentSlide(slideNumber);
      }
    }, timeout);
  }

  setCurrentSlide(slideNumber) {
    if (!this.container || !this.logo) return;
    
    // Remove current class from all slides
    this.container.querySelectorAll('.slide').forEach(slide => {
      slide.classList.remove('current');
    });
    
    // Add current class to the active slide
    const currentSlide = this.container.querySelector(`.slide${slideNumber}`);
    if (currentSlide) {
      currentSlide.classList.add('current');
      this.currentSlideIndex = slideNumber - 1;
      this.updateLogoColor();
    }
  }

  updateLogoColor() {
    if (!this.logo) return;
    
    const currentSlide = this.container?.querySelector('.slide.current');
    if (currentSlide && currentSlide.classList.contains('color-text-bg-false')) {
      this.logo.classList.add('cc_logo_w');
    } else {
      this.logo.classList.remove('cc_logo_w');
    }
  }

  initializeNavigation() {
    const navContainer = document.getElementById('hero_nav');
    if (!navContainer) return;
    
    let pageCounter = 0;
    const heroSections = document.querySelectorAll('.herosections.marketsSensitive');
    
    heroSections.forEach((section, index) => {
      if (section.getAttribute('nav') === 'true') {
        const sectionId = section.id;
        const blockSlidegb = section.getAttribute('blockSlidegb');
        const count = index + 1;
        pageCounter = pageCounter + 1;
        
        const navItem = document.createElement('li');
        navItem.className = `${blockSlidegb} iSlide slide slide${pageCounter}${count === 1 ? ' current' : ''}`;
        navItem.innerHTML = `<a href="#${sectionId}">${pageCounter}</a>`;
        
        navContainer.appendChild(navItem);
      }
    });
  }
}

customElements.define('hero-section', HeroSection);

